import { ChangeDetectionStrategy, Component, inject, Signal } from '@angular/core';

import { ChurnFlowReasonInfoboxService } from '@core/churn-flow-logic';
import { ChurnFlowSolutionCardI, ChurnReason } from '@core/churn-flow-types';
import {
  ChurnFlowReasonTemplateComponent,
  ChurnFlowSolutionCardComponent,
  ChurnFlowStepTemplateComponent,
} from '@core/churn-flow-ui';
import { TranslatePipe } from '@core/i18n-legacy';
import { ButtonComponent, IconComponent } from '@core/user-interface-legacy';

import { ChurnFlowInsightsComponent } from '../../components/churn-flow-insights/churn-flow-insights.component';
import { ChurnFlowReasonBaseComponent } from '../../components/churn-flow-reason-base.component';

@Component({
  selector: 'tlc-churn-organizational-changes-page',
  templateUrl: './churn-organizational-changes-page.component.html',
  styleUrls: ['./churn-organizational-changes-page.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ButtonComponent,
    ChurnFlowInsightsComponent,
    ChurnFlowReasonTemplateComponent,
    ChurnFlowSolutionCardComponent,
    ChurnFlowStepTemplateComponent,
    IconComponent,
    TranslatePipe,
  ],
})
export class ChurnOrganizationalChangesPageComponent extends ChurnFlowReasonBaseComponent {
  protected readonly reason = ChurnReason.OrganizationalChanges;
  public readonly infoboxMessage: Signal<string | undefined> = inject(
    ChurnFlowReasonInfoboxService,
  ).getReasonInfoboxMessage(ChurnReason.OrganizationalChanges);

  public readonly contactSpecialist: ChurnFlowSolutionCardI = {
    iconVariant: 'dialog',
    title: this.t('tlc.churn_flow.steps.organizational_changes.solutions.contact_specialist.title'),
    incentives: [
      this.t(
        'tlc.churn_flow.steps.organizational_changes.solutions.contact_specialist.incentive_1',
      ),
      this.t(
        'tlc.churn_flow.steps.organizational_changes.solutions.contact_specialist.incentive_2',
      ),
    ],
    ctaText: this.t('tlc.churn_flow.steps.organizational_changes.solutions.contact_specialist.cta'),
  };

  public contactSpecialistAction(): void {
    this.analytics.trackAlternativeSelected('schedule_call');
    this.openIntercom(
      this.t(
        'tlc.churn_flow.steps.organizational_changes.solutions.contact_specialist.intercom_message',
      ),
    );
  }
}
